import { render, staticRenderFns } from "./hisAddPatient.vue?vue&type=template&id=8c3408f0&scoped=true"
import script from "./hisAddPatient.vue?vue&type=script&lang=js"
export * from "./hisAddPatient.vue?vue&type=script&lang=js"
import style0 from "./hisAddPatient.vue?vue&type=style&index=0&id=8c3408f0&prod&lang=css"
import style1 from "./hisAddPatient.vue?vue&type=style&index=1&id=8c3408f0&prod&scoped=true&lang=css"
import style2 from "./hisAddPatient.vue?vue&type=style&index=2&id=8c3408f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3408f0",
  null
  
)

export default component.exports